import React, { FC, ReactNode, useContext, useState } from 'react';
import { getPlatformStyles, isDesktop } from '@direct-frontend/platform-code';
import { useIsomorphicLayoutEffect } from '@direct-frontend/stdlib';

import { cn } from '../../lib/css/className/className';
import { HStack, VStack } from '../Stack';

getPlatformStyles({
    desktop: import('./ModalButtons@desktop.css'),
    mobile: import('./ModalButtons@mobile.css'),
});

export const cls = cn('ModalButtons');

interface ButtonsContextProps {
    onButtonsChange: (buttons: ReactNode) => void;
}

export const ButtonsContext = React.createContext<ButtonsContextProps>({
    onButtonsChange: () => {},
});

export interface ButtonsProviderProps {
    children: ReactNode;
}

export const ButtonsProvider: FC<ButtonsProviderProps> = function ButtonsProvider({ children }) {
    const [buttons, onButtonsChange] = useState<ReactNode>(null);

    return (
        <ButtonsContext.Provider value={{ onButtonsChange }}>
            {children}
            {buttons}
        </ButtonsContext.Provider>
    );
};

export interface ModalButtonsProps {
    /**
     * Кнопки внизу модалки
     */
    children: ReactNode;

    /**
     * Расположение кнопок (работает только в мобильной версии)
     * @default 'horizontal'
     */
    type?: 'horizontal' | 'vertical';
}

export const ModalButtons: FC<ModalButtonsProps> = function ModalButtons({ children, type = 'horizontal' }) {
    const { onButtonsChange } = useContext(ButtonsContext);
    const StackComponent = type === 'horizontal' || isDesktop() ? HStack : VStack;

    useIsomorphicLayoutEffect(() => {
        onButtonsChange(
            <StackComponent className={cls()} gap="8">
                {children}
            </StackComponent>,
        );

        return () => {
            onButtonsChange(null);
        };
    }, [children, StackComponent, onButtonsChange]);

    return null;
};
